<template>
    <div class="p-3">
        <h4 class="text-dark">Control Center: User Accounts</h4>

        <div class="d-flex justify-content-end">
            <add-user
                :organization="organization"
                :subscription="subscription"
                :roles="roles"
                @update-list="fetchAccounts()"
                dusk="add-user"
            >
                Add User
            </add-user>
        </div>

        <div class="alert alert-info mt-3">
            Adding a user does not automatically send an invite to your team member. When you are
            ready to invite users to the platform click the right hand three dots.
        </div>

        <div class="my-3 px-3 form-group row">
            <input
                type="text"
                class="form-control form-control-sm col-8 col-sm-4"
                v-model="search"
                placeholder="Search by First or Last Name"
            />
            <button
                class="btn btn-sm btn-primary font-weight-bold text-uppercase mx-3"
                @click="fetchAccounts()"
            >
                Search
            </button>
        </div>

        <paginator :pagination="pagination" @fetch="fetchAccounts($event)"></paginator>

        <table class="table table-striped mt-3">
            <thead>
                <tr class="">
                    <td class="p-1">Name</td>
                    <td class="p-1">E-mail</td>
                    <td class="p-1">Role</td>
                    <td class="p-1"></td>
                </tr>
            </thead>
            <tbody class="">
                <tr :class="u.invite_id ? 'table-info' : ''" v-for="u in accounts">
                    <td :class="!u.name ? 'font-italic' : ''">
                        <a v-if="u.therapist_id" :href="`therapists/${u.therapist_id}/details`">{{
                            u.name
                        }}</a>
                        <span v-else="">{{ u.name ? u.name : "Pending invitation" }}</span>
                    </td>
                    <td :class="!u.name ? 'font-italic' : ''">{{ u.email }}</td>
                    <td :class="!u.name ? 'font-italic' : ''">{{ getRole(u) }}</td>
                    <td>
                        <template>
                            <div class="dropdown text-right">
                                <button
                                    class="btn btn-sm btn-link text-black"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <i class="fa fa-ellipsis-v"></i>
                                </button>
                                <div
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="delete-recurring"
                                >
                                    <a
                                        v-if="u.name && !u.last_login_date"
                                        class="cursor-pointer dropdown-item small"
                                        @click="sendInvitePassword(u.user_id)"
                                        >Send Invite</a
                                    >
                                    <a
                                        v-if="!u.name"
                                        class="cursor-pointer dropdown-item small"
                                        @click="showCancelInviteModal(u)"
                                        >Cancel Invite</a
                                    >
                                    <a
                                        v-if="!u.name"
                                        class="cursor-pointer dropdown-item small"
                                        @click="showResendInviteModal(u)"
                                        >Resend Invite</a
                                    >
                                    <a
                                        v-if="canChangeRole(u) && !u.invite_id"
                                        class="cursor-pointer dropdown-item small"
                                        @click="showChangeRoleModal(u)"
                                        >Change Role</a
                                    >
                                    <a
                                        v-if="u.name && u.user_id != user.id"
                                        class="cursor-pointer dropdown-item small text-danger"
                                        @click="showRemoveUserModal(u)"
                                        >Remove User</a
                                    >
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>

        <paginator :pagination="pagination" @fetch="fetchAccounts($event)"></paginator>

        <modal-component
            :id="'user-accounts-modal'"
            :visible="modal.visible"
            :title="modal.title"
            :size="modal.size"
            @close="resetModal()"
        >
            <!--CHANGE ROLES-->
            <div v-if="modal.type === 0">
                <div class="form-group row px-2">
                    <label
                        for="edit-role"
                        class="col-4 col-form-label text-uppercase text-dark font-weight-bold"
                        >Role:
                    </label>
                    <select
                        id="edit-role"
                        class="col-8 form-control form-control-sm"
                        v-model="selectedAccount.role_id"
                    >
                        <option v-for="r in roles.filter(r => r.id !== 1)" :value="r.id">{{
                            r.name
                        }}</option>
                    </select>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <div class="d-flex justify-content-end">
                            <a
                                id="save-role"
                                class="btn btn-sm btn-primary text-white font-weight-bold text-uppercase"
                                @click="saveRole()"
                                style="min-width: 6rem;"
                                >Save</a
                            >
                        </div>
                    </div>
                </div>
            </div>

            <!--CANCEL AN INVITATION-->
            <div v-if="modal.type === 1">
                <p class="text-center">
                    Are you sure you want to cancel the invitation sent to
                    {{ selectedAccount.email }}?
                </p>
                <div class="d-flex w-100 justify-content-between align-items-center py-3">
                    <small
                        ><a
                            class="link-primary text-primary font-weight-bold text-uppercase"
                            @click="resetModal()"
                            >No, keep invitation</a
                        ></small
                    >
                    <button
                        id="remove-invite"
                        class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                        @click="removeTeamInvite(selectedAccount.invite_id)"
                    >
                        Yes, cancel invitation
                    </button>
                </div>
            </div>

            <!--RESEND INVITE-->
            <div v-if="modal.type === 2">
                <p class="text-center">
                    Are you sure you want to resend the invitation sent to
                    {{ selectedAccount.email }}?
                </p>
                <div class="d-flex w-100 justify-content-between align-items-center py-3">
                    <small
                        ><a
                            class="link-primary text-primary font-weight-bold text-uppercase"
                            @click="resetModal()"
                            >No, don't resend</a
                        ></small
                    >
                    <button
                        id="resend-invite"
                        class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                        @click="resendTeamInvite(selectedAccount.invite_id)"
                    >
                        Yes, resend invite
                    </button>
                </div>
            </div>

            <!--REMOVE USER FROM ORGANIZATION-->
            <div v-show="modal.type === 3">
                <template v-if="selectedAccount">
                    <p class="text-center">
                        Are you sure you want to remove {{ selectedAccount.name }}?
                    </p>
                    <div class="d-flex w-100 justify-content-between align-items-center py-3">
                        <small
                            ><a
                                class="link-primary text-primary font-weight-bold text-uppercase"
                                @click="resetModal()"
                                >No, don't remove</a
                            ></small
                        >
                        <button
                            id="remove-user"
                            class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                            @click="removeUser(selectedAccount.user_id)"
                        >
                            Yes, remove
                        </button>
                    </div>
                </template>
                <p>
                    Removing a user from the <b>{{ organization.name }}</b> account will decrease
                    the subscription from <b>{{ subscription.quantity }}</b> seats to
                    <b>{{ subscription.quantity - 1 }}</b> seats.
                </p>
                <invoice-preview
                    :organization="organization"
                    :subscription="subscription"
                    ref="previewRemove"
                ></invoice-preview>
            </div>
        </modal-component>

        <div class="my-2">
            <div v-if="success" class="alert alert-success">
                <a href="#" class="close" data-dismiss="alert">&times;</a>
                <span>{{ success }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import InvoicePreview from "../widgets/UpcomingInvoicePreview";
import ModalComponent from "../ui/ModalComponent";
import AddUser from "../widgets/AddUserWidget";
import Paginator from "../ui/Paginator";
import { permissions } from "../../plugins/permissions";
import { helpers } from "../../plugins/helpers";
import { errors } from "../../plugins/errors";

export default {
    name: "UserAccounts",
    props: ["user", "organization", "subscription"],
    mixins: [permissions, errors],
    components: {
        InvoicePreview,
        AddUser,
        ModalComponent,
        Paginator,
    },
    data() {
        return {
            accounts: [],
            selectedAccount: null,
            search: "",
            modal: {},
            modals: [
                {
                    visible: false,
                    title: "Change Role",
                    type: 0,
                },
                {
                    visible: false,
                    title: "Cancel invite",
                    type: 1,
                },
                {
                    visible: false,
                    title: "Resend invite",
                    type: 2,
                },
                {
                    visible: false,
                    title: "Remove User",
                    type: 3,
                },
            ],
            roles: [],
            success: null,
            preview: null,
            pagination: {},
            page: 1,
        };
    },
    created() {
        this.fetchOrganizationRoles();
        this.fetchAccounts();
    },

    methods: {
        fetchAccounts(page) {
            let queryString = "?";
            queryString += `&page=${page || this.page}`;
            queryString += this.search ? `&q=${this.search}` : "";
            axios.get(`/accounts-invites${queryString}`).then(r => {
                this.pagination = r.data.accounts;
                this.accounts = r.data.accounts.data;
            });
        },

        canChangeRole(user) {
            // USER AND SUPERUSER CAN'T EDIT THEIR ROLE
            if (user.user_id === this.user.id) {
                return false;
            }
            // USER HAS PERMISSION TO EDIT STAFF
            return this.canEditStaff;
        },

        showResendInviteModal(invite) {
            this.selectedAccount = invite;
            this.modal = this.modals[2];
            this.modal.visible = true;
        },

        showCancelInviteModal(invite) {
            this.selectedAccount = invite;
            this.modal = this.modals[1];
            this.modal.visible = true;
        },

        showRemoveUserModal(user) {
            this.$refs.previewRemove.getUpcomingInvoicePreview(-1);
            this.selectedAccount = user;
            this.modal = this.modals[3];
            this.modal.visible = true;
        },

        showChangeRoleModal(user) {
            this.selectedAccount = {
                user_id: user.user_id,
                role_id: _.get(user, "organization.role_id", null),
            };
            this.modal = this.modals[0];
            this.modal.visible = true;
        },

        resetModal() {
            this.modal = {};
            this.selectedAccount = null;
        },

        saveRole() {
            helpers.toggleSpinner("save-role");
            const payload = { role_id: this.selectedAccount.role_id };
            axios
                .patch(
                    `/api/organizations/${this.organization.id}/users/${
                        this.selectedAccount.user_id
                    }`,
                    payload
                )
                .then(r => {
                    this.fetchAccounts();
                    this.resetModal();
                    helpers.toggleSpinner("save-role");
                })
                .catch(e => {
                    console.error(e);
                    helpers.toggleSpinner("save-role");
                });
        },

        resendTeamInvite(id) {
            helpers.toggleSpinner("resend-invite");
            axios
                .post(`/api/organizations/${this.organization.id}/invites/${id}/resend`)
                .then(r => {
                    this.modal.visible = false;
                    helpers.toggleSpinner("resend-invite");
                })
                .catch(e => {
                    console.error(e);
                    helpers.toggleSpinner("resend-invite");
                });
        },

        removeTeamInvite(id) {
            helpers.toggleSpinner("remove-invite");
            axios
                .delete(`/api/organizations/${this.organization.id}/invites/${id}`)
                .then(r => {
                    this.subscription.quantity--;
                    this.modal.visible = false;
                    this.fetchOrganizationInvites();
                    helpers.toggleSpinner("remove-invite");
                })
                .catch(e => {
                    console.error(e);
                    helpers.toggleSpinner("remove-invite");
                });
        },

        removeUser(id) {
            helpers.toggleSpinner("remove-user");
            axios
                .delete(`/api/organizations/${this.organization.id}/users/${id}`)
                .then(r => {
                    this.subscription.quantity--;
                    this.modal.visible = false;
                    this.fetchAccounts();
                    helpers.toggleSpinner("remove-user");
                })
                .catch(e => {
                    console.error(e);
                    helpers.toggleSpinner("remove-user");
                });
        },

        fetchOrganizationRoles() {
            axios
                .get(`/api/organizations/${this.organization.id}?with=roles`)
                .then(r => {
                    this.roles = r.data.roles;
                })
                .catch(e => {
                    console.error(e);
                });
        },

        getRole(user) {
            let role = this.roles.find(r => r.id === user.role_id);
            if (role) {
                return role.name;
            }
            return "";
        },

        sendInvitePassword(id) {
            axios
                .post(`/api/organizations/${this.organization.id}/users/${id}/create`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.success = "Invite sent successfully.";
                    }
                });
        },
    },
};
</script>

<style scoped></style>
